import {
  call,
  put,
  select,
  fork,
  takeLatest
} from 'redux-saga/effects';
// import { browserHistory } from 'react-router';
import loader from '../../../../../util/loader/loader';
import {
  LOAD_CONTENT,
  SET_DATA,
  SET_ADDRESS,
  DL_PAGE_LOADED
} from './multipleAddress';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {NORMALIZE_DATA} from '../../../dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  errorPageByFlow
} from '../../../common/common';

// WATCHERS
export function* loadAddressesWatch() {
  yield takeLatest(LOAD_CONTENT, loadAddressesWorker);
}

export function* setAddressWatch() {
  yield takeLatest(SET_ADDRESS, setAddressWorker);
}

export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}

// WORKERS
export function* loadAddressesWorker() {
  try {
    yield put(showGlobalSpinner({hideContent: true}));

    const currentAddresses = yield select(state => state.accountMultipleAddress.customerBillingAccounts);

    if (currentAddresses.length > 1) {
      yield put(hideGlobalSpinner());

      return;
    }

    const errorPage = yield select(errorPageByFlow);
    const success = yield call(dataProvider.load, [
      {state: 'accountMultipleAddress'}
    ], {errorPage});

    if (!success) {
      return;
    }

    yield put({
      type: DL_PAGE_LOADED
    });

    yield put(hideGlobalSpinner());
  } catch(e) {
    yield put(hideGlobalSpinner());
    // browserHistory.push(navigationRoutes[navigationSteps.movers.ERROR].path);
  }
}

export function* setAddressWorker({accountNumber}) {
  try {
    const errorPage = yield select(errorPageByFlow);
    const endpoint = navigationRoutes[navigationSteps.account.MULTIPLE_ADDRESS].endpoints.setAddress(accountNumber);
    const success = yield call(loader.request, endpoint, {hideContentWhileLoading: false, errorPage});

    if (!success) {
      return;
    }
  } catch(e) {
    //console.log(e)
  }
}

export function* normalizeWorker({key, data}) {
  if (key !== 'accountMultipleAddress') {
    return;
  }

  yield put({
    type: SET_DATA,
    payload: {
      ...data
    }
  });
}

export default function* accountMultipleAddressSagas() {
  yield [
    fork(loadAddressesWatch),
    fork(setAddressWatch),
    fork(normalizeWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Account/multipleAddress/multipleAddressSagas.js
 **/